import { useEffect, useRef, useState } from "react";
import { Box, TableCell, Tooltip } from "@mui/material";

export default function TruncatedCell({ value, sx, after }) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    setIsTruncated(Boolean(el && el.scrollWidth > el.clientWidth));
  }, [value]);

  const styles = {
    content: { display: "flex", alignItems: "center", gap: 1, minWidth: 0 },
    text: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      minWidth: 0,
    },
  };

  const text = (
    <Box component="span" ref={textRef} sx={styles.text}>
      {value}
    </Box>
  );

  return (
    <TableCell sx={sx}>
      <Box sx={styles.content}>
        {isTruncated ? <Tooltip title={value}>{text}</Tooltip> : text}
        {after}
      </Box>
    </TableCell>
  );
}
